import Vue from 'vue'
import Router from 'vue-router'

import { SQS_EMBARGO_YEAR, SQS_NO_PK_YEAR, SQS_PK_SECRET_KEYS } from '@/report-settings'

import NotFound from '@/components/NotFound'

import Snapshot2025 from '@/components/sqs/2025/Snapshot'
import Snapshot2024 from '@/components/sqs/2024/Snapshot'
import Snapshot2023 from '@/components/sqs/2023/Snapshot'
import Snapshot2022 from '@/components/sqs/2022/Snapshot'
import Snapshot2021 from '@/components/sqs/2021/Snapshot'
import Snapshot2020 from '@/components/sqs/2020/Snapshot'
import Snapshot2019 from '@/components/sqs/2019/Snapshot'
import Snapshot2018 from '@/components/sqs/2018/Snapshot'
import Snapshot2017 from '@/components/sqs/2017/Snapshot'

Vue.use(Router)

const sqsComponents = {
  2025: Snapshot2025,
  2024: Snapshot2024,
  2023: Snapshot2023,
  2022: Snapshot2022,
  2021: Snapshot2021,
  2020: Snapshot2020,
  2019: Snapshot2019,
  2018: Snapshot2018,
  2017: Snapshot2017
}
const sqsYearsReverse = Object.keys(sqsComponents).sort().reverse()
const sqsLatestYear = sqsYearsReverse[0]
const sqsLatestPublicYear = +sqsLatestYear === SQS_EMBARGO_YEAR ? sqsYearsReverse[1] : sqsLatestYear
const sqsPKSecretKey = SQS_PK_SECRET_KEYS[SQS_NO_PK_YEAR]

const routes = [
  // Aliases to most recent versions
  {
    path: '/snapshot/',
    redirect: `/snapshot/${sqsLatestPublicYear}/`
  },
  {
    path: '/snapshot/0/:dbn/:report_type/',
    redirect: `/snapshot/${sqsLatestPublicYear}/:dbn/:report_type/`
  },
  // Aliases to add slashes
  {
    path: '/:app_name(snapshot)/:year(\\d{4})',
    redirect: '/:app_name/:year/',
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/snapshot/:year(\\d{4})/:dbn/:report_type?',
    redirect: '/snapshot/:year/:dbn/:report_type/',
    pathToRegexpOptions: { strict: true }
  }
]

// Add route for public but slightly-embargoed report for PK preview
if (sqsPKSecretKey) {
  routes.push({
    path: `/snapshot/:pk_secret_key(${sqsPKSecretKey})/:dbn?/:report_type?/`,
    name: `Snapshot${SQS_NO_PK_YEAR}PKEmbargo`,
    component: sqsComponents[SQS_NO_PK_YEAR],
    props: true,
    pathToRegexpOptions: {
      sensitive: true,
      strict: true
    }
  })
}

// Add real report routes for Snapshot
for (let year in sqsComponents) {
  routes.push({
    path: `/snapshot/${year}/:dbn?/:report_type?/`,
    name: `Snapshot${year}`,
    component: sqsComponents[year],
    props: true,
    pathToRegexpOptions: { strict: true }
  })
}

// Catch all for known apps but unknown params
routes.push({
  path: '/:app_name(snapshot)/*',
  redirect: '/:app_name/'
})

// Catch all for 404
routes.push({ path: '*', component: NotFound })

export default new Router({
  mode: 'history',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js